export default {
    ...require("./fr/applepay.json"),
    ...require("./fr/bank.json"),
    ...require("./fr/banktransfer.json"),
    ...require("./fr/barter.json"),
    ...require("./fr/card.json"),
    ...require("./fr/cryptocurrency"),
    ...require("./fr/eNaira.json"),
    ...require("./fr/fawrypay.json"),
    ...require("./fr/googlepay.json"),
    ...require("./fr/internet-banking.json"),
    ...require("./fr/mobile-money.json"),
    ...require("./fr/mpesa.json"),
    ...require("./fr/nqr.json"),
    ...require("./fr/migo.json"),
    ...require("./fr/paga.json"),
    ...require("./fr/payattitude.json"),
    ...require("./fr/paypal.json"),
    ...require("./fr/plaid.json"),
    ...require("./fr/qr.json"),
    ...require("./fr/ussd.json"),
    ...require("./fr/voucher.json"),
    ...require("./fr/wechat.json"),
    ...require("./fr/ui.json"),
    ...require("./fr/paymenterrors.json"),
    ...require("./fr/init.json"),
    ...require("./fr/instructions.json"),
    ...require("./fr/paymentoptions.json"),
    ...require("./en/opay.json"),
    ...require("./fr/capitec.json"),
};